const Help = ({ fill, size }: string | any | { fill: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : "24"}
    height={size ? size : "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ? fill : "#2c2c2c"}
      d="M12.235 8.386a1.82 1.82 0 0 0-2.023 1.188.909.909 0 1 1-1.715-.603 3.636 3.636 0 0 1 7.067 1.212c0 1.39-1.032 2.31-1.769 2.8a7.3 7.3 0 0 1-1.532.772l-.032.011-.01.004h-.004l-.001.001-.289-.862.288.863a.91.91 0 0 1-.576-1.725l.014-.005a4 4 0 0 0 .331-.134c.225-.1.517-.247.803-.437.627-.418.959-.863.959-1.29a1.82 1.82 0 0 0-1.511-1.795M12 15.636a.91.91 0 1 0 0 1.819h.01a.91.91 0 1 0 0-1.819z"
    ></path>
    <path
      fill={fill ? fill : "#2c2c2c"}
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.182a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default Help;
